import useShallowEqualSelector from '../../../custom_hooks/useShallowEqualsSelector';
import { ReducerKeys } from '../../../redux/reducers';
import { StateStatus } from '../../utils/common';
import { useSelector } from 'react-redux';

interface MessageOutgoingListElement {
  message_outgoing_id: number;
  applicant_id: number;
  file_name: string;
  // message_text: string;
  message_type: string;
  originating_country: string;
  destination_country: string;
  message_id: string;
  correlation_id: string;
  ccncsi_correlation_id: string;
  status: number;
  error: string;
  sent_flag: number;
  read_flag: number;
  message_ref_id: number;
  transmision_date: string;
  created_by: string;
  created_at: string;
  modified_by: string;
  modified_at: string;
}

interface MessageOutgoingListData {
  paging: Paging;
  items: MessageOutgoingListElement[];
}

interface Paging {
  page: number;
  pageSize: number;
  total: number;
}

interface MessageOutgoingListOutput {
  status: StateStatus;
  data: MessageOutgoingListData | null;
}

export const useGetMessageOutgoingList = (): MessageOutgoingListOutput => {
  const data = useShallowEqualSelector(
    (state: any) =>
      state[ReducerKeys.MESSAGE_OUTGOING_REDUCER].messageOutgoingList
  );
  return data;
};

interface ICountry {
  country_id: number;
  code: string;
  description: string;
  numeric_code: number;
}

export const useGetMemberStateExcludeCyprusCountries = (): Array<ICountry> => {
  const data = useSelector(
    (state: any) =>
      state[ReducerKeys.MESSAGE_OUTGOING_REDUCER].memberStateExcludeCyprusList
        .data
  );
  return data;
};
